/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

export const typeDefaultForm: Record<string, string> = {
  PLACE_ORDER: 'placeOrder',
  CONTACT: 'contactUs',
  CUSTOMER_LOGIN: 'generateCustomerToken',
  CUSTOMER_FORGOT_PASSWORD: 'requestPasswordResetEmail',
  CUSTOMER_CREATE: 'createCustomerV2',
  CUSTOMER_EDIT: 'updateCustomerV2',
  NEWSLETTER: 'subscribeEmailToNewsletter',
  PRODUCT_REVIEW: 'createProductReview',
  SENDFRIEND: 'SENDFRIEND',
  BRAINTREE: 'BRAINTREE',
};
